export enum TimeUnit {
  Days = 'days',
  Months = 'months',
  Years = 'years'
}